import { Vue, Component } from 'vue-property-decorator';
import SVGLogoPulinetFull from '@/assets/img/logo/logo-pulinet-full.svg';
import { Form } from 'element-ui';
import emailPreferenceClient from '@/core/api/email-preferences-service';
import {
  IUserEmailPreferencesDTO,
  UserEmailPreferencesDTO,
} from '@/../client-generator/generated-clients/email-preferences';

@Component({
  components: {
    SVGLogoPulinetFull,
  },
  i18n: {
    messages: {
      it: {
        saved: 'Preferenze salvate correttamente',
        savePreferences: 'Salva preferenze',
        goToHome: 'Vai al portale',
      },
    },
  },
})
export default class EmailPreferences extends Vue {
  isLoading = false;
  token: string | undefined = undefined;
  showSaveConfirm = false;

  formModel: IUserEmailPreferencesDTO = {
    userFirstName: '',
    userLastName: '',
    userEmail: '',
    systemEmailsConsent: true,
    promotionalNewsEmailsConsent: false,
  };

  get formRules() {
    const required = {
      required: true,
      message: this.$t('validation.systemEmailsConsent'),
    };

    return {
      systemEmailsConsent: [required, { validator: this.requiredMailsValidator }],
    };
  }

  get versionNumber() {
    return `v${this.$config.FRONTEND_VERSION}`;
  }

  get fullName() {
    if (this.formModel.userFirstName) {
      return `${this.formModel.userFirstName} ${this.formModel.userLastName}`;
    }

    return '';
  }

  created() {
    this.token = this.$route.params.token;
  }

  mounted() {
    this.fetchUser();
  }

  async fetchUser() {
    this.isLoading = true;

    try {
      this.formModel = await emailPreferenceClient.preferencesGet(this.token);
      this.formModel.systemEmailsConsent = true;
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.isLoading = false;
    }
  }

  submit() {
    const $form = this.$refs.theForm as Form;

    $form.validate(async (isValid) => {
      if (!isValid) return;

      this.isLoading = true;

      try {
        await emailPreferenceClient.preferencesPut(this.token, new UserEmailPreferencesDTO(this.formModel));

        this.showSaveConfirm = true;
      } catch (error) {
        let messageError = 'error';

        switch (error.status) {
          default:
            messageError = this.$t('apiErrors.serverError').toString();
        }

        this.$message.error(messageError);
      } finally {
        this.isLoading = false;
      }
    });
  }

  requiredMailsValidator(rule, value, callback) {
    if (value !== true) {
      callback(new Error(this.$t('validation.systemEmailsConsent').toString()));
      return;
    }

    callback();
  }

  goToHome() {
    this.$router.push('/');
  }
}
